/** @format */

import { Link, useParams } from "react-router-dom";
import { CsvImportManagement } from "../../components/CsvImportManagement";
import { useBrand } from "../../hooks/useBrand";
import { useImportJobs } from "../../hooks/useImportJobs";
import { Locale } from "../../features/i18n/init";

export const AdminImportManagementPage = () => {
	const { brand } = useBrand();
	const { locale } = useParams<{ locale: Locale }>();
	const { jobs, isLoading, error, reload } = useImportJobs(brand);

	return (
		<section className="space-y-6">
			<div className="flex flex-wrap items-start justify-between gap-4">
				<div>
					<h2 className="text-[1.75rem] font-bold text-(--admin-color-primary)">Import history</h2>
					<p className="mt-2 text-sm text-slate-600">Manage imported questions</p>
				</div>
				<Link
					to={`/${locale}/admin/import`}
					className="rounded-md bg-(--admin-color-primary) px-4 py-2 text-sm font-semibold text-white shadow-sm hover:opacity-90"
				>
					Import questions
				</Link>
			</div>
			{isLoading && (
				<p role="status" className="text-sm text-slate-600">
					Loading import jobs…
				</p>
			)}

			{error && (
				<div
					role="alert"
					className="rounded-lg border text-center border-red-200 bg-red-50 p-6 shadow-(--admin-shadow-raised)"
				>
					<p className="font-semibold text-red-900">Failed to load import jobs</p>
					<p className="mt-1 text-sm text-red-900">{error}</p>
					<button
						type="button"
						onClick={reload}
						className="mt-4 cursor-pointer rounded-md border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
					>
						Retry
					</button>
				</div>
			)}
			{!isLoading && !error && <CsvImportManagement jobs={jobs} />}
		</section>
	);
};
